export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-mobile-signal-7f7fb18622efd016cd8fb41040d6d437.svg";